import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ChartFilters } from 'interfaces/store/chartFilters';

const initialState: ChartFilters = {
  growthMotion: [],
  softwareSector: [],
  primaryCustomer: []
};

const chartFiltersSlice = createSlice({
  name: 'chartFilters',
  initialState,
  reducers: {
    resetFilters: state => {
      state.softwareSector = [];
      state.growthMotion = [];
      state.primaryCustomer = [];
    },
    applyFilters: (state, action: PayloadAction<ChartFilters>) => {
      state.softwareSector = action.payload.softwareSector;
      state.growthMotion = action.payload.growthMotion;
      state.primaryCustomer = action.payload.primaryCustomer;
    }
  }
});

export const { resetFilters, applyFilters } = chartFiltersSlice.actions;

export default chartFiltersSlice.reducer;
